import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Typography, 
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { showLoadingMessage, 
        } from '../util/util';
import { INFO,
         CONSTS,
         CONSLOG,
         TIMES, } from '../util/object';
import { GATag, Stack } from "../util/tools";
import { loadAIModel } from '../util/aiMain';
import { appContext } from "./index";
import { Wrap,
         Hourglass,
         Roller,
         MergeDots,
         Cube,
         Ellipsis} from "../util/spinner";
import { FaAxosLogo,
         FaSportsEngineLogo,
         FaStar,
         FaPlayer,
         FaBottle,
         FaTripod,
         FaPhone,
         FaTeamsnapLogo,
        } from '../assets/Icons'; 
import { initAnalyzer} from '../util/analysis'
import { initDefender} from '../util/defender'
import { initPerformance} from '../util/performance'
import { initVideoDisplay} from '../util/annotate'
import Intro from './Intro';
import { AuthClass } from '../class/AuthClass';

var auth = new AuthClass();

const auth_useStyles = makeStyles(theme => ({
    splash_root: {
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        maxWidth: '100%',
        backgroundColor:'#4a4c4c',
        position: 'relative',
    },
    splash_container: {
        display: 'flex',
        flexDirection: 'column',
        //maxHeight: '90vh', 
        //maxWidth: '60%',
        //minWidth: '350px',
        //marginTop: '2vh',
        maxWidth: '800px',          // also adjust title_container
        width: '100%',
        height: '100%',
        margin: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '0',
        zIndex: '1000',
    },
    background: {
        width: '100%',
        objectFit: 'cover',
        zIndex: '0',
        //position: 'absolute',
        //maxWidth: '100%',
        //maxHeight: '100%',
        //height: '100%',
        //overflow: 'hidden',
        //backgroundColor:'#ff0000',
        //clipPath: 'inset(0 0 200px 0)',
    },

    vert_title_container: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
        padding: '0',
        margin: '0',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '4vh',
        zIndex: '100',
    },
    vert_drill_text: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
		fontSize: '12vw',     // 3.3rem
		fontWeight: '700',
		lineHeight: '1.1',
		letterSpacing: '0.012em',
        //color: '#283888', 
        color: '#fff', 
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '35vh',
        textAlign: 'center',
        textShadow: "4px 4px 12px #363232",
    },
    vert_interactive_text: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
		fontSize: 'calc(5% * 70)',  //'12vw', '3.5rem'
		fontWeight: '700',
		lineHeight: '1.1',
		letterSpacing: '0.012em',
        color: '#9e9fa3',        //'#bdf6fa', 
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '75vh',
        textAlign: 'center',
        textShadow: "4px 4px 12px #363232",
    },

    test_box_container: {
        width: '200px',
        height: '200px', 
        position: 'absolute',
        top: '0',
        left: '0',
        padding: '0',
        margin: '0',
        background: 'grey',
        zIndex: '1000',
    },

    horz_title_container: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
        padding: '0',
        margin: '0',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '4vh',
        zIndex: '100',
    },
    horz_drill_text: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
		fontSize: '6vw',     // 3.3rem
		fontWeight: '700',
		lineHeight: '1.1',
		letterSpacing: '0.012em',
        //color: '#283888', 
        color: '#fff', 
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '35vh',
        textAlign: 'center',
        //textShadow: "4px 4px 12px #363232",
        textShadow: "6px 4px #363232",
    },
    horz_interactive_text: {
        maxWidth: '800px',          // also adjust title_container
        position: 'absolute',
		fontSize: 'calc(5% * 70)',  //'5vw', '3.5rem'
		fontWeight: '700',
		lineHeight: '1.1',  //'1.6',
		letterSpacing: '0.012em',
        color: '#9e9fa3',   //'#bdf6fa', 
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '75vh',
        textAlign: 'center',
        //textShadow: "4px 4px 12px #363232",
        textShadow: "5px 3px #363232",
    },



    status_container: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    status_text: {
        //display: "flex",      // flex overrides textAlign
		fontSize: '1.7rem',
		fontWeight: '300',
		lineHeight: '1.6',
		letterSpacing: '0.012em',
        color: '#888', 
        width: '100%',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
    },
    spinner_cube: {
        display: "flex",
        height: '200px',
        width: '200px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    spinner_container: {
        display: "flex",
        //position: "absolute",
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '1vh',
        height: '200px',
        width: '200px',
    },
    hidden: {
        display: "none",
    },
    easter_container: {
        position: 'absolute',
        right: '0',
        bottom: '0',
        width: '60px',
        height: '60px',
        zIndex: '400',
        //backgroundColor: 'red',
    },
    conslog_container: {
        position: 'absolute',
        left: '0',
        right: '0',
		fontSize: '0.6rem',
        padding: '10px',
        margin: '0',
        height: "100%",
        width: "100%",
        overflow: "auto",
        zIndex: '300',
        backgroundColor: 'green',
    },
}));

// Display splash screen, allow auth to happen before routing to Auth or Console
const Splash = (props) => {
    const classes = auth_useStyles();
    const [ ShowIntro, setShowIntro ] = useState(false); 
    const [ SplashTarget, setSplashTarget ] = useState(""); 
    const [ StatusText, setStatusText ] = useState("");
    const [ VerticalMode, setVerticalMode ] = useState(true);
    const [ Text1, setText1 ] = useState("");
    const [ Text2, setText2 ] = useState("");
    const [ Background, setBackground ] = useState("axos");
    const [ ShowConsole, setShowConsole ] = useState(null);
    const [ DelayTimer, setDelayTimer ] = useState(null);
    const [ Delay, setDelay] = useState(null);
    const [ DebugMode, setDebugMode] = useState(null);

    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        console.log("setState.splash:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }

    useEffect(() => {

        setStatusText("Axos Agility Training")

        if ((props.NoAI == true) || (INFO.no_ai_mode == true)) {
            console.log("Splash.125:   ====== ENTER NO AI MODE...test=", props.NoAI);
            INFO.no_ai_mode = true; 
            INFO.perf_mode = false;
            INFO.practice_mode = false;
            setState("ai_avail", true);     // NEED TO SET THIS TO GET UI TO FLOW
            setSplashTarget("/menu");
        } else {
            initAI();
        }

        showIntro();        // for inset animation, mostly for running "one-shot auto-start drills" from youtube
        setVerticalMode(INFO.vertical_mode);

        return function cleanup() {
            if (DelayTimer) {
                clearTimeout(DelayTimer);
            }
        }

    }, [1]); 


    useEffect(() => {
        if (ShowConsole === false) {
            startRedirect();        // delay a bit to show the splash
        } else {
            //console.log("catalog.293:   Catalog Cons Log  =", out);
            var out = CONSLOG.replace(/(?:\r\n|\r|\n)/g, '<br>');       // insert <br> for line break
            var ele = document.getElementById('cons_log')
            if (ele !== null) {
                ele.innerHTML = out;
            }
        }
    }, [ShowConsole]); 


    useEffect(() => {
        // KLUDGE: Wait for React to refresh
        //
        if (Delay && (DebugMode === null)) {
            //console.log("Splash.316:          . . . .  CALLING REDIRCT   delay=",Delay, " DebugMode=",DebugMode);
            startRedirect();        // delay a bit to show the splash
        }
    }, [Delay]); 

    async function showIntro() {
        var debug = auth.getCookie(CONSTS.COOKIE_DEBUG_SPLASH).toString();
        var delay = CONSTS.SPLASH_DISPLAY_DELAY;
        if(debug === "true") {
            //console.log("Splash.INIT.224:     ++++++++ ENTER DEBUG SPLASH MODE");
            delay = 100000000;
            setShowIntro(true);
        }
        setDelay(delay);
        console.log("Splash.INIT.51:       SPLASH running useEffect()  delay=",delay, " debug=",debug, "  props=", props);
    }


    async function startRedirect() {
        //console.log("Splash.334:          . . . .  SETTING REDIRCT TIMER   delay=",Delay);
        var delay_timer = setTimeout(()=> {
            console.log("Splash.178:                 ************* END OF SPLASH PAGE DISPLAY **********   delay=",Delay," authed=",State.authed);
            processRedirect();
        },  Delay);
        setDelayTimer(delay_timer);
    }

    useEffect(() => {
        console.log("Splash.260:        ShowIntro=",ShowIntro, " Text1=",Text1, " Text2=",Text2);
    }, [ShowIntro, Text1, Text2]); 

    useEffect(() => {
        setVerticalMode(INFO.vertical_mode);

        if(props.ActiveDrill !== null) {
            var drill = props.ActiveDrill;
            console.log("Splash.253:               drill=",drill);
            if ((drill !== undefined) && (drill.name !== undefined)) {
                setText1(drill.name);
            }
        }

        if(props.Splash !== null) {
            var contents = props.Splash;
            console.log("Splash.262:               contents=",contents);
            if ((contents !== undefined) && (contents[0] !== undefined)) {
                var content = contents[0];
                setText2(content.text);
            }
        }

        if ((props.Background !== null) && (props.Background !== false)) {
            var background = props.Background;
            console.log("Splash.271:               background=",background);
            if ((background !== null) && (background !== undefined)) {
                setBackground(background);
            }
        } else {
            setBackground("axos");
        }

    }, [INFO.vertical_mode, props.ActiveDrill, props.Splash, props.Background]); 


    async function initAI() {

        loadAIModel()
        .then(values => {
            console.log("Splash.380:  =>=>=>=>= AI out=", values);
            GATag("Training", "AI.Loading", "", 0);		 // (cat, act, lab, val)

            var time = ((TIMES.ai_loaded - TIMES.app_entry) / 1000).toFixed(3);
            GATag("Training", "AI.Ready", "", time);		 // (cat, act, lab, val)
            var spinner = document.getElementById('spinner_container');
            if ((spinner !== undefined) && (spinner !== null)) {
                spinner.style.display = "none";
            }

            // DO ALL INITIALIZATION HERE
            //
            initAnalyzer();
            initDefender();
            initPerformance();
            //initVideoDisplay();    // do that in menu

            setStatusText("");
            setState("ai_avail", true);
            console.log("Splash.80:   ====== AI init returned  model=", values);
            TIMES.session_start = TIMES.ai_loaded;      // placeholder for bucket write, in case of starting issues
            window.dispatchEvent(INFO.system_ready_event);       // all is ready, can restart at this point

            //console.log("Splash.80:   AI init returned  pose=", pose, " yolo=",yolo);
            //processRedirect();        // always wait for delay instead
        })
    }


    const processRedirect = () => {
        if(State.authed === true) {
            if(INFO.direct_start_mode === true) {
                setSplashTarget("/drill");
            } else {
                setSplashTarget("/menu");
            }
        } else {
            setSplashTarget("/auth");
        }

    };

    const renderRedirect = () => {
        if (SplashTarget !== "") {
            GATag("menu", SplashTarget, "jump");  // (cat, act, lab, val)
            console.log("#################### splash.renderRedirect:   Showing ", SplashTarget, " Delay=",Delay,"  authed=", State.authed);
            return <Redirect to={SplashTarget} />
        }

        return ""
    }

    // dynamic in-game debug toggle
    //
    const handleSplashDebug = () => {
        console.log("splash.482:      SPLASH DEBUG MODE DETECED  DebugMode=",DebugMode, " Delay=",Delay);
        switch (DebugMode) {
            case null:
                // must cancel previous timer first!
                //
                if (DelayTimer) {
                    clearTimeout(DelayTimer);
                }
                setShowConsole(true);       // show console
                setDelay(100000000);
                setDebugMode(1);
                break;
            case 1:
                setShowConsole(false);      // no console but still wait
                setShowIntro(true);         // debug <Intro>
                setDelay(100000000);
                setDebugMode(2);
                break;
            case 2:
                setShowConsole(false);      // back to normal
                setShowIntro(false);         // debug <Intro>
                setDelay(1500);
                setDebugMode(null);
                break;
        };
    }


    return (
        <React.Fragment>
            <Container id="splash_root" className={classes.splash_root} >
                <Container id="splash_container" className={classes.splash_container} >

                    {ShowConsole && <Container id="cons_log" className={classes.conslog_container}>CONSOLE</Container>}
                    {(VerticalMode === true) ?
                        <React.Fragment>
                            <img id="background" src={CONSTS.SPLASH_ASSET_PATH+Background} className={classes.background} />
                            <Intro Show={ShowIntro} />
                            <Container id="title_box" className={classes.vert_title_container}>
                                <Container id="drill_text" className={classes.vert_drill_text}>
                                    {Text2.toUpperCase()}
                                </Container>


                                <Container id="interactive_text" className={classes.vert_interactive_text}>
                                    {Text2.toUpperCase()}
                                </Container>
                            </Container>
                        </React.Fragment>
                    :
                        <React.Fragment>
                            <img id="background" src={CONSTS.SPLASH_ASSET_PATH+Background} className={classes.background} />
                            <Intro Show={ShowIntro} />

                            {false && <Container id="test_box" className={classes.test_box_container}>
                                        <FaPhone style={{ width: "200px", height: "200px",
                                                color: "yellow", zIndex: "300" }} {...props} />
                            </Container> }

                            <Container id="title_box" className={classes.horz_title_container}>
                                <Container id="drill_text" className={classes.horz_drill_text}>
                                    {Text1.toUpperCase()}
                                </Container>

                                <Container id="interactive_text" className={classes.horz_interactive_text}>
                                    {Text2.toUpperCase()}
                                </Container>
                            </Container>
                        </React.Fragment>
                    }

                    <div key="easter3" id="result_easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleSplashDebug}/>

                    {renderRedirect()}
                </Container>
            </Container>
        </React.Fragment>
    )
}

export default withRouter(Splash);
